import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Box, Grommet } from "grommet";
import { normalizeColor } from "grommet/utils";
import * as React from "react";
import { SkeletonTheme } from "react-loading-skeleton";
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import DarkModeSwitch, { useDarkMode } from "./components/DarkModeSwitch";
import { NotFound, useIFrame, useQuery } from "./general/Helpers";
import Home from "./home/Home";
import Theme from "./utils/Theme";
import Admin from "./home/Admin";
import View from "./home/View";

const back = <FontAwesomeIcon icon={["fad", "arrow-left"]} size="lg"></FontAwesomeIcon>;

function App() {
    const [isDarkMode, toggleDarkMode] = useDarkMode();
    const [showDarkModeSwitch, setShowDarkModeSwitch] = React.useState(true);

    return (
        <Grommet id="main" full theme={Theme} themeMode={isDarkMode ? "dark" : "light"}>
            <SkeletonTheme baseColor={normalizeColor("background-back", Theme, isDarkMode)} highlightColor={normalizeColor("background-front", Theme, isDarkMode)}>
                {showDarkModeSwitch && <DarkModeSwitch></DarkModeSwitch>}
                <BrowserRouter>
                    <Routes>
                        <Route path="/*" element={<Home />}></Route>
                        <Route path="/view/:id" element={<View />}></Route>
                        <Route path="/admin/*" element={<Admin />}></Route>
                    </Routes>
                </BrowserRouter>
            </SkeletonTheme>
        </Grommet>
    );
}

export default App;
